import Vue from "vue";
import Vuex from "vuex";

const fb = require("../firebaseConfig.js");

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    clients: [],
    currentClient: null
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setClients(state, val) {
      state.clients = val;
    },
    setCurrentClient(state, val) {
      state.currentClient = val;
    }
  },
  actions: {
    clearData({ commit }) {
      commit("setCurrentUser", null);
      commit("setUserProfile", {});
      commit("setCurrentClient", null);
    },
    fetchCurrentClient({ commit, state }) {
      fb.clientsCollection
        .doc(state.currentClient.id)
        .get()
        .then(res => {
          const client = res.data();
          client.id = res.id;
          commit("setCurrentClient", client);
        })
        .catch(err => {
          console.log(err);
        });
    },
    fetchUserProfile({ commit, state }) {
      fb.usersCollection
        .doc(state.currentUser.uid)
        .get()
        .then(res => {
          commit("setUserProfile", res.data());
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  modules: {}
});

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit("setCurrentUser", user);
    store.dispatch("fetchUserProfile");
    fb.clientsCollection.orderBy("name", "asc").onSnapshot(querySnapshot => {
      let clientsArray = [];
      querySnapshot.forEach(doc => {
        let client = doc.data();
        client.id = doc.id;
        clientsArray.push(client);
      });

      store.commit("setClients", clientsArray);
    });
  }
});

export default store;
